<script>
	// export let name;
	import Select from "svelte-select";
	import About from "./About.svelte";
	// import Login from "./Auth.svelte";
	import { to_number } from "svelte/internal";
	import * as Studier from "/Users/paal/PanterDev/1svelte/kommer-jeg-inn/src/data/sokere22.json";
	import * as Studier1 from "/Users/paal/PanterDev/1svelte/kommer-jeg-inn/src/data/sokere21.json";
	import * as Kjonn from "/Users/paal/PanterDev/1svelte/kommer-jeg-inn/src/data/kjonn22.json";
	import AddInRes from "./data/comp/add_inRes.svelte";
	// import AddHeader from "./data/comp/add_header.svelte";

	import { Wave } from "svelte-loading-spinners";

	const wait = () => new Promise((res) => setTimeout(res, 3000));

	const studierSearch = [];
	let sel;
	let sel1;
	let selkjonn;
	let nr = 1;
	let nr1 = 1;
	let show = false;
	let showKar = false;

	let loading = false;

	// STUDIER Json
	// 	{
	//     "Studiekode": 185724,
	//     "Studienavn": "Rettsvitenskap (jus), høst",
	//     "Lærested": "UIO",
	//     "Lærestedsnavn": "Universitetet i Oslo",
	//     "Planlagte studieplasser": 224,
	//     "Søkere førstevalg": 1748,
	//     "Førstevalg per studieplass": 7.803571428571429
	//   },

	//KJONN Json
	// 	{
	//     "Lærested": "DMMH",
	//     "Lærestedsnavn": "Dronning Mauds Minne Høgskole for barnehagelærerutdanning",
	//     "Utdanningsområde": "LÆRER",
	//     "Studiekode": "253 130",
	//     "Studienavn": "Barnehagelærer",
	//     "Kvinne_Søkere": "701",
	//     "Mann_Søkere": "215",
	//     "Totalt_Søkere": "916",
	//     "Kvinne_Søknader": "701",
	//     "Mann_Søknader": "215",
	//     "Totalt_Søknader": "916",
	//     "Kvinne_førstevalg": "114",
	//     "Mann_førstevalg": "34",
	//     "Totalt_førstevalg": "148"
	//   },

	Studier.default.forEach(function (value) {
		let kvinner;
		let menn;
		let s = value["Førstevalg per studieplass"];
		//1 desimaler
		let ss = Math.round(s);
		// let ss = Math.round((s + Number.EPSILON) * 100) / 100

		// 8 - 9  pers
		if (s < ss) {
			let d = ss--;
			// s="+ "+ss+"//"+s;
			s = ss + " til " + d;
		}
		// 7 - 8 personer
		if (s > ss) {
			let d = ss++;
			s = d + " til " + ss;
		}

		//Kjønnsfordeling
		// Kjonn.default.forEach(function (valueKjonn) {
		// 	// console.log(
		// 	// 		"er desse like?",
		// 	// 		valueKjonn.Studiekode.replaceAll("\\s+","")+ "==" +value.Studiekode.toString());
		// 	if (valueKjonn.Studiekode.replaceAll("\\s+","") == value.Studiekode.toString()) {

		// 		kvinner = valueKjonn.Kvinne_Søknader;
		// 		menn = Mann_Søknader;
		// 	}
		// });

		// Kjonn.default.
		//legger inn alle fra json.(er)
		studierSearch.push({
			label: value.Studienavn + " - " + value.Lærested,
			group: value.Lærestedsnavn,
			value: value.Studiekode,
			plasser: value["Planlagte studieplasser"],
			fvalg: value["Søkere førstevalg"],
			fvalgprplass: s,
			nr,
			// totsok: kvinner + menn,
			// totmenn: menn,
			// totkvinne: kvinner,
		});
		// rangere etter søkertall
		nr++;
	});

	const groupBy = (item) => item.group;
	const optionIdentifier = "id";
	const getOptionLabel = (option) => option.name;
	const getSelectionLabel = (option) => option.name;

	// let studieSearch = Studier;
	//static info startup
	let value = {
		label: "Skriv inn studie ..",
		group: "value.Lærested",
		value: "",
	};

	function handleClear(event) {
		// console.log(event);
		sel = sel1 = selkjonn = null;
		show = false;

		// event.detail will be null unless isMulti is true and user has removed a single item
	}

	function handleClick() {
		if (sel === null) {
			alert("Velg et studie først.");
		}
		if (sel != null) {
			// loading = !loading;

			show = !show;
		}
	}

	function handleSelect(event) {
		// console.log("selected item", event.detail);
		sel = event.detail;
		if (show) {
			// sel = sel1 = selkjonn = null;
			show = false;
		}

		// console.log("kode: ",event.detail.value.toString());

		//KJONNSFORDELING
		Kjonn.default.forEach(function (valueKjonn) {
			if (
				valueKjonn.Studiekode.replaceAll(" ", "") ==
				event.detail.value.toString()
			) {
				let kvinneDelSum = Math.round(
					parseFloat(
						valueKjonn?.Kvinne_Søknader.replaceAll(" ", "") /
							valueKjonn?.Totalt_Søknader.replaceAll(" ", "")
					) * 100
				);

				let kvinneDelMann = Math.round(
					parseFloat(
						valueKjonn?.Kvinne_Søknader.replaceAll(" ", "") -
							valueKjonn?.Mann_Søknader.replaceAll(" ", "")
					)
				);
				// Lager Kjønnsfordeling av 100. 6/94 eller 40/60 typ.
				let kvinneDelSumFordeling =
					kvinneDelSum + "/" + (100 - kvinneDelSum);
				//ProsentAndel Kvinner til menn
				let kvinneDelSumProsent =
					kvinneDelMann > 0
						? kvinneDelMann + " flere kvinner enn menn"
						: kvinneDelMann * -1 + " flere menn enn kvinner";

				let sum = valueKjonn.Totalt_Søknader;
				let mann = valueKjonn.Mann_Søknader;
				let kvinne = valueKjonn.Kvinne_Søknader;

				//KJONNSFORDELING DATA
				selkjonn = {
					mann,
					kvinne,
					sum,
					kvinneDelSumFordeling,
					kvinneDelSumProsent,
				};
			}
		});

		//FJOR ÅRETS DATA

		// 		{
		//     "Studiekode": "217 906",
		//     "Studienavn": "Toll, vareførsel og grensekontroll",
		//     "Lærested": "UIS",
		//     "Lærestedsnavn": "Universitetet i Stavanger",
		//     "Planlagte studieplasser": "35",
		//     "Søkere førstevalg": "2 064",
		//     "Førstevalg per studieplass": "59,0"
		//   },

		Studier1.default.forEach(function (valueStud1) {
			if (
				valueStud1.Studiekode.replaceAll(" ", "") ==
				event.detail.value.toString()
			) {
				// console.log("2021", valueStud1);

				let value = parseFloat(
					valueStud1.Studiekode.replaceAll(" ", "")
				);
				let plasser = parseFloat(
					valueStud1["Planlagte studieplasser"].replaceAll(" ", "")
				);
				let fvalg = parseFloat(
					valueStud1["Søkere førstevalg"].replaceAll(" ", "")
				);
				let fvalgprplass = parseFloat(
					valueStud1["Førstevalg per studieplass"].replaceAll(" ", "")
				);
				sel1 = {
					nr1,
					value,
					plasser,
					fvalg,
					fvalgprplass,
					sokerTallString:
						fvalg < sel.fvalg
							? "SØKERTALLET HAR ØKT"
							: "SØKERTALLET MINKET",
				};
				// console.log("22 / 21 plasser", fvalg +" // "+ sel.fvalg);
			}
			nr1++;
		});
		//reset. Count
		nr1 = 1;
	}
</script>

<main style="margin:0px;padding:0px; ">
	<!-- <Login /> -->
	<div
		class="vertText"
		style="

		background-color: #f1742d;
		position: absolute;
		width: 0px;
		height: 2400px;
		<!-- height: 400px; -->
		margin: 0px;
		left: 1%;
		"
	>
		<h6
			style="font-family: 'Rubik';
			font-weight: 300;
			font-size: 12px;
			margin: 10px;
			text-overflow: ellipsis;
			margin-top: 200px;

			overflow: hidden;
			white-space: nowrap;


			
			color: rgba(0, 0, 0, 0.4);
			word-spacing: 10px;
			
			writing-mode: vertical-rl;
			text-orientation: mixed;"
		>
			&nbsp; &nbsp; &nbsp; &nbsp; {sel?.label ?? ". . . . "} &nbsp; &nbsp;
			&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; {sel?.label ?? ". . . . "}
			&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; {sel?.label ??
				". . . . "} &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;{sel?.label ??
				". . . . "} &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;{sel?.label ??
				". . . . "}
		</h6>
	</div>
	<body>
		<!-- <h4
			style="padding-top: 0px;padding-bottom: 32px; text-align: center; word-spacing: 2px; "
		>
			MED DATA FRA SAMORDNET OPPTAK FRA 2013

	
			<span class="black" /> TIL
			<span class="orange"> 2022</span>
			<br />
		</h4> -->
		<div
			class="addContainer"
			style="max-width: 360px; max-height: 360px; background-color: grey;"
		>
			<!-- <AddHeader /> -->
		</div>
		<h1>KOMMER JEG INN PÅ</h1>
		<div class="row">
			<div style="padding-top: 5px;" class="search">
				<Select
					on:clear={handleClear}
					items={studierSearch}
					placeholder="Velg noe annet"
					{value}
					{groupBy}
					on:select={handleSelect}
				/>
			</div>

			<!-- <h1
				style="margin: 5px 10px 0px 0px;padding-bottom: 10px; padding-left: 10px; width:30px; "
			>
				?
			</h1> -->
		</div>

		<!-- BRUK DENNE NÅR DU HAR KARTERER MED I BERGENINGEN  -->
		<!-- <label>
			<input type="checkbox" bind:checked={showKar} />
			Søk med karakterene mine
		</label>

		{#if !showKar == false && show == false}
			<h2
				style="width: 300px; text-align: start; margin: 14px; padding-top: 60px; padding-bottom: 64px;"
			>
				Med <input
					style="border: 0px;color:#F1742D; background-color: hsla(22, 88%, 56%, 0.05); font-weight: 500;"
					type="number"
					value="44.0"
					placeholder="44.0"
					step="0.1"
					id="tentacles"
					name="tentacles"
					min="01.0"
					max="99.0"
				/>
				i f. vitnemål? eventuelt med
				<input
					style="border: 0px;color:hsla(360, 88%, 56%, 1); background-color: hsla(360, 88%, 56%, 0.1); font-weight: 500; height: 40px;"
					type="number"
					value="44.0"
					placeholder="44.0"
					step="0.1"
					id="tentacles"
					name="tentacles"
					min="01.0"
					max="99.0"
				/> ordintært?
			</h2>
		{/if} -->
		{#if show == false}
			<button
				class="button"
				style="margin-bottom: 32px;margin-top: 300px;"
				disabled={!sel}
				on:click={handleClick}
			>
				SØK
			</button>
		{/if}
		{#if show == true}
			{#await wait()}
				<div
					class="loading"
					style="margin-left: 5px;margin-top: 236px;"
				>
					<!-- <Wave
						size="128"
						color="#FF3E00"
						unit="px"
						duration="1.2s"
					/> -->

					<Wave
						size="128"
						color="#FF3E00"
						unit="px"
						duration="1.3s"
					/>
				</div>
			{:then a}
				<!-- <p>
					
			Hva får jeg vite? - <a href="https://svelte.dev/tutorial"
				>Eksempel Søk</a
			>
			
		</p>
		<button>SØK</button>

		<p>ll</p> -->
				{#if sel != null && show}
					<span class="with-line" />
					<h4>OPPDATERT APRIL 2022</h4>

					<div class="boxStat">
						<h2>
							DET ER
							<span class="blue"
								>{sel?.plasser} STUDIEPLASSER</span
							>
							PLANLAGT
						</h2>

						<h3>
							{selkjonn?.sum} HAR SØKT, AV DESSE ER <br />
							<span class="blue">{sel?.fvalg} FØRSTEVALG</span>
						</h3>

						<h5>
							For hver studieplass er det {sel?.fvalgprplass} personer
							som konkurerer om en den.
						</h5>
					</div>

					<div class="boxStat">
						<h2>
							DET ER
							<span class="blue"
								>{sel?.plasser == sel1?.plasser
									? "LIKE MANGE"
									: sel?.plasser > sel1?.plasser
									? "EN ØKE I"
									: "MINDRE"} <br /> STUDIEPLASSER
							</span>
							PLANLAGT
						</h2>

						<h3>
							{sel1?.plasser} PLASSER I 2021 <br />
							<span class="blue"
								>{sel?.plasser} PLASSER I 2022</span
							>
						</h3>

						<h5>
							Planlagte studieplasser kan påvirke poenggrensen
						</h5>
					</div>

					<div class="boxStatAdd">
						<AddInRes />
					</div>

					<span class="with-line-v" />

					<div class="boxStat">
						<h2>
							AV ALLE SOM SØKER ER
							<span class="blue"
								>KJØNNSFORDELINGEN <br />
								{selkjonn?.kvinneDelSumFordeling}</span
							>
						</h2>

						<h3>
							{selkjonn?.kvinne} KVINNER OG {selkjonn?.mann} MENN
						</h3>

						<h5>
							Av alle søkerene er det {selkjonn?.kvinneDelSumProsent}.
						</h5>
					</div>
					<!-- <span class="with-line-v" />
		<span class="with-line-e" />
		<h4 style="color: black;padding-bottom: 100px;">
			DATA ER HENTET FRA <br /> SAMORDENT OPPTAK
		</h4> -->
					<div class="boxStatAdd">
						<AddInRes />
					</div>

					<span class="with-line-v" />

					<div class="boxStat">
						<h2>
							<span class="blue"
								>{sel1?.sokerTallString} <br />
							</span>
							SIDEN 2021
						</h2>

						<h3>
							DET ER <span class="blue"
								>{sel?.fvalg - sel1?.fvalg < 0
									? sel1?.fvalg - sel?.fvalg + " FÆRRE"
									: sel?.fvalg - sel1?.fvalg + " FLERE"}</span
							>
							SØKERE <br />ENN I 2021
						</h3>

						<h5>
							Det var
							{sel1?.fvalg} førstevalgsøkere i 2021
							<!-- &''
				{sel1?.fvalg} søkere i 2021 -->
						</h5>
					</div>

					<div class="boxStat">
						<h2>
							<span class="blue">POPULARITETEN </span>
							TIL STUDIET ER
							<span class="blue">{sel?.nr}/{nr} </span>
						</h2>

						<h3>I 2021 VAR DET NR {sel1?.nr1}</h3>

						<h5>
							Det er {nr} studier totalt. Dette er <br /> nummer {sel?.nr}
							av antall søkere I 2022
						</h5>
					</div>
					<div class="boxStatAdd">
						<AddInRes />
					</div>

					<span class="with-line-v" />

					<!-- <span class="with-line-e" /> -->
					<!-- <h4 style="color: black;padding-bottom: 100px;">
						DATA ER HENTET FRA <br /> SAMORDENT OPPTAK
					</h4> -->
				{/if}
			{/await}
		{/if}

		<!-- {#if !show} -->

		{#if show == false}
			<!-- <span class="with-line" style="padding: 0px; 	" /> -->

			<span class="with-line-v" style="padding: 0px;" />

			<!-- <h4 style="padding-top: 48px;padding-bottom: 32px;">
				MED DATA FRA SAMORDNET OPPTAK <br />
				<span class="black"> 2013</span> -
				<span class="orange"> 2022</span>
			</h4> -->

			<h6 style="margin: 0px; margin-bottom: 8px; padding-top: 42px;">
				DETTE <br />
				<span style="padding-top: 42px;margin: 0px; " class="orange"
					>FÅR DU VITE</span
				>
			</h6>

			<div
				class="info"
				style="background-color: rgba(241, 116, 45, 0.05); text-align: start; padding: 32px; padding-top: 10px;padding-bottom: 10px; width: 275px;"
			>
				<h3 style="font-size: 14px ; font-weight: 400;">
					<span
						class="black"
						style="font-size: 20px; font-weight: 600;"
					>
						ANTALL SØKERE</span
					> <br />
					Hvor mange som har studiet som sitt førstevalg. Antall personer
					som har søkt på studiet i år. Både første gangsvitnemål og ordinærtvitnemål.
					<br /> <br />
					<br /><br />

					<span
						class="black"
						style="font-size: 20px; font-weight: 600;"
					>
						STUDIEPLASSER
					</span><br />
					Antall studieplasser som er planlagt på studiet i år. Sammenlignet
					med hvor mange plasser det var året før. <br /> <br />
					<br /><br />
					<span
						class="black"
						style="font-size: 20px; font-weight: 600;"
					>
						KJØNNSFORDELING
					</span><br />
					Se om studiet er mer populært blant kvinner eller menn. Alle
					som har søkt er med i denne statistikken. <br /> <br />
					<br /><br />
					<span
						class="black"
						style="font-size: 20px; font-weight: 600;"
					>
						POPULARITETEN
					</span><br />
					Sammenlinger søkertallet med andre studier. Det er flere hundre
					studier å velge mellom! Listen er lang. Finn ut hvor studiet
					ditt ligger.
				</h3>
			</div>

			<h4 style="text-align: start; margin-top: 8px; margin-left: 42px;">
				MED FERSKE TALL FRA - <span class="orange"> APRIL 2022 </span>
			</h4>
			<span class="with-line-v" style="padding: 43px;" />

			<div class="stats" style="font-weight: 400;">
				<h2 style="font-size: 30px;">
					12,4% <br />
					<span class="blue"> MINDRE SØKERE </span>
				</h2>

				<h4>I ÅR</h4>
				<br />
				<br />
				<br />
				<br />
				<h2 style=" font-size: 30px;">
					<span
						class="orange"
						style=" font-weight: 400;  font-size: 22px;"
					>
						2022</span
					><br />

					134 954 SØKERE
				</h2>

				<h4 style="margin: 40px; padding-top: 18px; ">
					SAMMENLIGNET MED
				</h4>
				<h2 style=" font-size: 30px;">
					<span
						class="red"
						style="color: red; font-weight: 400;  font-size: 22px;"
					>
						2021</span
					><br />

					154 088 SØKERE
				</h2>
			</div>

			<div class="pad" style="height: 200px;" />
		{/if}
		<span class="with-line" />

		<h4
			style="padding-top: 0px;padding-bottom: 32px; text-align: center; word-spacing: 2px; "
		>
			MED DATA FRA SAMORDNA OPPTAK FRA 2013

			<!-- MED DATA FRA SAMORDNET OPPTAK FRA 2013 -->
			<span class="black" /> TIL
			<span class="orange"> 2022</span>
			<br />
		</h4>

		<!-- <h4 style="color: black;padding-bottom: 100px;">
			DATA ER HENTET FRA <br /> SAMORDENT OPPTAK
		</h4> -->

		<!-- {/if} -->
		<!-- <About /> -->
	</body>
	<a href="/privacy">Privacy</a><br /><br />
	<a href="/terms">Terms & Conditions</a>
</main>

<style>
	a {
		color: black;
	}
	.boxStat {
		/* justify-content: center; */

		/* position: relative; */
		width: 250px;
		background-color: whitesmoke;
		color: rgb(0, 0, 0);
		height: 250px;
		/* margin-left: 24px; */
		margin: 0 auto;
		margin-top: 30px;
		padding: 20px;
		padding-bottom: 10;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}
	.boxStatAdd {
		/* justify-content: center; */

		/* position: relative; */
		max-width: 290px;
		max-height: 290px;
		background-color: whitesmoke;
		color: rgb(0, 0, 0);
		/* margin-left: 24px; */
		margin: 0 auto;
		margin-top: 30px;
		/* padding: 20px; */
		/* padding-bottom: 10; */
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}
	main {
		/* background-color: #e5e5e5; */

		text-align: center;
		padding: 1em;
		/* max-width: 240px; */
		margin: 0 auto;
	}

	h1 {
		color: black;
		margin-bottom: 0;
		text-transform: uppercase;
		font-size: 32px;
		font-weight: 900;
		font-family: "Rubik";
	}
	h2 {
		color: black;
		margin-bottom: 0;
		/* text-transform: uppercase; */
		font-size: 20px;
		font-weight: 500;
		font-family: "Rubik";
	}
	h3 {
		font-weight: 600;
		font-size: 16px;
		color: hsla(0, 0%, 0%, 0.5);
	}
	h4 {
		font-size: 12px;
		color: hsla(0, 0%, 0%, 0.5);
		font-family: "Rubik";
		font-weight: 500;
		margin-top: 10px;
	}

	.info {
		text-align: start;
	}

	h5 {
		font-size: 12px;
		color: hsla(0, 0%, 0%, 0.5);
		font-family: "Rubik";
		font-weight: 400;
		margin-top: 10px;
	}
	h6 {
		font-size: 24px;
		color: hsla(0, 0%, 0%, 0.4);
		font-family: "Rubik";
		font-weight: 500;
		text-align: start;
		/* margin-top: 10px; */
	}
	.blue {
		color: #0d15e4;
	}
	.black {
		color: black;
	}
	.orange {
		color: #f1742d;
	}
	.search {
		text-align: start;
		width: 330px;
		padding-left: 0px;
		font-family: "Rubik";
		font-size: 13px;
		font-weight: 500;
		color: #f1742d;
		--background: hsla(22, 88%, 56%, 0.05);
		--border: 0px solid blue;
		--borderRadius: 0px;
		--placeholderColor: #f1742d;
		--itemColor: black;
		--groupItemPaddingLeft: 8px;
	}
	.row {
		display: grid;
		grid-template-columns: auto auto auto;
		grid-gap: 0px;
		padding: 0px;
		justify-content: center;
	}
	body {
		margin: 0 auto;
		justify-content: center;

		text-align: center;
		display: grid;
		/* justify-content: center; */
		/* align-content: center; */
		/* max-width: 2rem; */
		/* width: 280px; */
	}

	.with-line {
		display: block;
	}

	.with-line:before,
	.with-line:after {
		content: "";
		display: inline-block;
		border-top: 1px solid #00000080;
		width: 160px;
		vertical-align: middle;
		/* margin: 0 0.5em; */
	}
	.with-line-v:before,
	.with-line-v:after {
		content: "";
		display: inline-block;
		border-left: 0.5px solid #00000080;
		/* width: 160px; */
		height: 70px;
		vertical-align: middle;
		margin-top: 20px;
		padding: 0px;
	}

	/* .with-line-e:before,
	.with-line-e:after {
		content: "";
		display: inline-block;
		border-top: 1px solid #000;
		width: 62px;
		vertical-align: middle;
		margin: 0px;
		/* margin: 0 0.5em; */
	/* } */

	.button {
		/* width: 80px; */
		color: black;
		font-weight: 600;
		border: none;
		height: 50px;
		font-family: "Rubik";
		margin: 20px 120px;
		background-color: whitesmoke;
	}

	button:disabled,
	button[disabled] {
		opacity: 0.6;
	}
</style>
